import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PathContext from './context/path';
import MobileContext from './context/mobile';
import About from './pages/About';
import Main from './pages/Main/Main';
// import StoryAlexandra from './pages/StoryAlexandra';
import StoryDmitry from './pages/StoryDmitry/StoryDmitry';
import StoryEvgenia from './pages/StoryEvgenia';
// import StoryFelix from './pages/StoryFelix';
import StorySvetlana from './pages/StorySvetlana/StorySvetlana';
import Wrap from './pages/Wrap';
import Vacancies from './pages/Vacancies';
import WrapVacancies from './pages/WrapVacancies';
import Vacancy from './pages/Vacancy';
import Internship from './pages/Internship';
import StoryEkaterina from './pages/StoryEkaterina';
import NotFound from './pages/NotFound';
import { YandexMetrika } from './components/YandexMetrika';

const App = () => {
  const [isMobile, setMobile] = useState(true);

  useEffect(() => {
    const handleMobile = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      if (window.innerWidth < 768 && !isMobile) {
        setMobile(true);
      }
      if (window.innerWidth > 767 && isMobile) {
        setMobile(false);
        document.documentElement.style.setProperty('--vh', ``);
      }
    };
    handleMobile();
    window.addEventListener('resize', handleMobile);
    return () => {
      window.removeEventListener('resize', handleMobile);
    };
  }, [isMobile]);
  // const basename = '/demo/rfarm-new';
  const basename = '';
  const basenameContext = basename;

  return (
    <MobileContext.Provider value={isMobile}>
      <PathContext.Provider value={basenameContext}>
        <Router basename={basename}>
          <Routes>
            <Route path="/" element={<Wrap />}>
              <Route index element={<Main />} />
              {/* <Route path='story-alexandra' element={<StoryAlexandra />} /> */}
              <Route path="story-svetlana" element={<StorySvetlana />} />
              <Route path="story-evgenia" element={<StoryEvgenia />} />
              <Route path="story-ekaterina" element={<StoryEkaterina />} />
              {/* <Route path='story-felix' element={<StoryFelix />} /> */}
              <Route path="story-dmitry" element={<StoryDmitry />} />
              <Route path="about" element={<About />} />
              <Route path="vacancies/" element={<WrapVacancies />}>
                <Route index element={<Vacancies />} />
                <Route path="vacancy" element={<Vacancy />} />
                <Route path="internship" element={<Internship />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Router>

        <YandexMetrika />
      </PathContext.Provider>
    </MobileContext.Provider>
  );
};

export default App;
